import { useState } from "react";
import { getUnixTime, sub } from "date-fns";
import { useDashboardActivityQuery } from "../../graphql/generated";
import useGqlClient from "../../hooks/useGqlClient";
import { DealActivityFeed } from "./DealActivityFeed";

export function RecentActivity(props: { dealId: string }) {
  const client = useGqlClient();
  const [startDate] = useState<number>(
    getUnixTime(sub(new Date(), { days: 30 }))
  );
  const [endDate] = useState<number>(getUnixTime(new Date()));

  const dashboardActivityQuery = useDashboardActivityQuery(client, {
    dealId: props.dealId,
    activityInput: {
      startDate: startDate,
      endDate: endDate,
      count: 1000,
    },
  });

  if (dashboardActivityQuery.error) {
    return null;
  }

  if (dashboardActivityQuery.isPending || !dashboardActivityQuery.data) {
    return (
      <div className="bg-white border border-gray-100 p-5">
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-gray-100 rounded w-1/3"></div>
          <div className="h-3 bg-gray-100 rounded w-full"></div>
          <div className="h-3 bg-gray-100 rounded w-2/3"></div>
        </div>
      </div>
    );
  }

  const activities = dashboardActivityQuery.data.dealActivity.activity;

  return (
    <div className="bg-white border border-gray-100 overflow-hidden">
      <div className="px-5 py-4 border-b border-gray-100">
        <h3 className="font-semibold text-gray-900">Recent Activity</h3>
      </div>

      {activities.length === 0 ? (
        <div className="p-5 text-center">
          <p className="text-sm text-gray-500">No recent activity</p>
        </div>
      ) : (
        <div className="p-4">
          <DealActivityFeed activities={activities} mode="verbose" />
        </div>
      )}
    </div>
  );
}
